/** Loads the bake manifest the `/assets` viewer runs on — served at `/baked/manifest.json` (see `dev-server.ts`). */

import type { BakeManifest } from "@red-opus/baker/schema";

export async function loadManifest(): Promise<BakeManifest> {
  const response = await fetch("/baked/manifest.json");
  if (!response.ok) {
    throw new Error(`failed to load /baked/manifest.json: ${response.status} ${response.statusText}`);
  }
  return (await response.json()) as BakeManifest;
}
